(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[431],{

/***/ 282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90270);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59693);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41810);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93871);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: '6px 8px'
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: '5px 15px',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabledBackground)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat((0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat((0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      },
      '&$focusVisible': {
        boxShadow: 'none'
      },
      '&:active': {
        boxShadow: 'none'
      },
      '&$disabled': {
        boxShadow: 'none'
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },

    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inherit',
      marginRight: 8,
      marginLeft: -4,
      '&$iconSizeSmall': {
        marginLeft: -2
      }
    },

    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8,
      '&$iconSizeSmall': {
        marginRight: -2
      }
    },

    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18
      }
    },

    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 20
      }
    },

    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 22
      }
    }
  };
};
var Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Button(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      endIconProp = props.endIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      startIconProp = props.startIcon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);

  var startIcon = startIconProp && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.startIcon, classes["iconSize".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))])
  }, startIconProp);
  var endIcon = endIconProp && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.endIcon, classes["iconSize".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))])
  }, endIconProp);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))], classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classes.label
  }, startIcon, children, endIcon));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiButton'
})(Button));

/***/ }),

/***/ 1532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18598);
/* harmony import */ var components_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50677);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _templateObject, _templateObject2, _templateObject3;






var Hero = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  background: ", ";\n  color: ", ";\n  padding: 40px 10px;\n  text-align: center;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.GREEN;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.WHITE;
});
var Content = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  max-width: ", ";\n  margin: auto;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.width.medium;
});
var Title = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(components_typography__WEBPACK_IMPORTED_MODULE_2__.H1)(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  color: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.BEIGE;
});

var PageHero = function PageHero(_ref5) {
  var title = _ref5.title,
      text = _ref5.text;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Hero, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Content, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Title, {
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
        children: text
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageHero);

/***/ }),

/***/ 39333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18598);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _templateObject, _templateObject2, _templateObject3;





var Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  display: flex;\n  align-items: baseline;\n"])));
var PriceText = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  font-size: ", ";\n  margin-left: ", ";\n"])), function (_ref) {
  var small = _ref.small;
  return small ? '24px' : '48px';
}, function (_ref2) {
  var showPrice = _ref2.showPrice;
  return showPrice && '4px';
});
var PriceCurrency = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  position: relative;\n  bottom: ", ";\n  right: 0px;\n"])), function (_ref3) {
  var small = _ref3.small;
  return small ? '8px' : '22px';
});

var PriceTag = function PriceTag(_ref4) {
  var price = _ref4.price,
      currency = _ref4.currency,
      small = _ref4.small;
  var showPrice = typeof price === 'number';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Wrapper, {
    children: [showPrice && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(PriceCurrency, {
      small: small,
      children: currency
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(PriceText, {
      small: small,
      showPrice: showPrice,
      children: price
    }), showPrice && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      children: "/m\xE5n"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PriceTag);

/***/ }),

/***/ 59054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18598);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2415);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91894);
/* harmony import */ var _PriceTag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39333);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50677);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);



var _excluded = ["item", "buttonColor"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var Card = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  padding: ", ";\n  background: ", ";\n  color: ", ";\n  min-width: 260px;\n  min-height: 350px;\n  border-radius: ", ";\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  box-shadow: ", ";\n  margin: ", ";\n  @media (max-width: ", ") {\n    margin: ", ";\n    margin-top: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.space.xsmall;
}, function (_ref2) {
  var popular = _ref2.popular,
      theme = _ref2.theme;
  return popular ? theme.palette.BEIGE_DARK : theme.palette.BEIGE;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.WHITE;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.medium;
}, function (_ref5) {
  var popular = _ref5.popular,
      theme = _ref5.theme;
  return "".concat(theme.boxShadowMedium, " ").concat(popular ? theme.palette.BEIGE : theme.palette.BEIGE_DARK);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.small;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakPoints.tablet;
}, function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.space.medium, " ").concat(theme.space.xxlarge, " ").concat(theme.space.small);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.medium;
});
var CardTitle = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_typography__WEBPACK_IMPORTED_MODULE_6__.H3)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  font-size: 14px;\n  margin: ", ";\n  color: ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.xsmall;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.palette.GREEN;
});
var Infobox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  text-align: center;\n  margin: 15px auto;\n  margin-bottom: auto;\n"])));
var InfoItem = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  font-size: 14px;\n  color: ", ";\n"])), function (_ref12) {
  var theme = _ref12.theme,
      popular = _ref12.popular;
  return theme.palette.WHITE;
});
var StyledButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  margin-bottom: 20px;\n"])));

var handleAction = function handleAction(action) {
  var value = action.value,
      type = action.type;

  switch (type) {
    case 'url':
      {
        next_router__WEBPACK_IMPORTED_MODULE_3___default().push(value);
        return;
      }

    case 'email':
      {
        window.location = 'mailto:' + value;
        return;
      }

    default:
      return;
  }
};

var PricingCard = function PricingCard(_ref13) {
  var _ref13$item = _ref13.item,
      title = _ref13$item.title,
      price = _ref13$item.price,
      description = _ref13$item.description,
      buttonText = _ref13$item.buttonText,
      currency = _ref13$item.currency,
      action = _ref13$item.action,
      popular = _ref13$item.popular,
      buttonColor = _ref13.buttonColor,
      rest = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref13, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(Card, _objectSpread(_objectSpread({
    popular: popular
  }, rest), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(CardTitle, {
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_PriceTag__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      price: price,
      currency: currency
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Infobox, {
      children: description === null || description === void 0 ? void 0 : description.map(function (item) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_10__/* .motion.div */ .E.div, {
          whileHover: {
            scale: 1.1,
            originX: 0,
            color: 'black'
          },
          transition: {
            type: 'spring',
            stiffness: 300
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(InfoItem, {
            popular: popular,
            children: item
          })
        }, item);
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(StyledButton, _objectSpread(_objectSpread({
      variant: "outlined"
    }, buttonColor ? {
      color: buttonColor
    } : {}), {}, {
      onClick: function onClick() {
        return handleAction(action);
      },
      children: buttonText
    }))]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (PricingCard);

/***/ }),

/***/ 91894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71383);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18598);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(282);


var _templateObject;



var Button = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  margin: 10px 0 8px;\n"])));
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 7374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ foretag; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(18598);
;// CONCATENATED MODULE: ./src/assets/images/business-group.png
/* harmony default export */ var business_group = ({"src":"/_next/static/media/business-group.22ee4fad.png","height":968,"width":834,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAclBMVEVMaXG2u8E1Nj2SkpvZ2NvQztM0NEFvb2+JhpCGhpGzs7no6Ojt7e34+Pg8aWGgtcFhgXN8fID29vS2tr4tWkZnZ21oYmUAI0Zkla2WlKOwsLlDOj5BQUWwsLjY2N39/f7h4eTR0dY3YoFdmodxcXJSU1OytK0BAAAAH3RSTlMAgbnH/oowAieX7/v3/Pnr/Y33av6n+x2H/lH9zqalF+lemAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEBJREFUeJwFwQUCgCAAALGjBOxuBev/X3QD55U6VsTy9Nu7M99lPX6SqdKxCCeYS2fBgEtjHgQWH9vQYUlkMyQ/eXwDim1Mb24AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/assets/images/dashboard.png
/* harmony default export */ var dashboard = ({"src":"/_next/static/media/dashboard.39c7d076.png","height":1320,"width":814,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAJFBMVEX5+vnj5OP19PTs7ez16uH////W5eHv5tvMzMvF3trPz86r0Moog1ZSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKUlEQVR4nAXBhwEAIAzDMCedwP//IjGTmeCqwrvXIAlQBBCSoc8Bd7/4DZwAj+oxaf4AAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/components/PageHero.js
var PageHero = __webpack_require__(1532);
// EXTERNAL MODULE: ./src/components/PricingCard.js
var PricingCard = __webpack_require__(59054);
// EXTERNAL MODULE: ./src/components/typography/index.js + 5 modules
var typography = __webpack_require__(50677);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(7878);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/foretag.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;













var pricingInfo = {
  title: 'Företag',
  description: ['Företagsadministration', 'Länkar', 'Sociala medier ', 'Delningar', 'QR-kod', 'Lokalisering', 'Analytics', 'Anpassade färger'],
  buttonText: 'Kontakta oss',
  action: {
    type: 'email',
    value: config/* default.EMAIL */.Z.EMAIL
  }
};
var Section = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: ", ";\n  margin: auto;\n  padding: 10px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.width.medium;
});
var StyledP = (0,emotion_styled_browser_esm/* default */.Z)(typography.P)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 28px;\n  letter-spacing: 1px;\n"])));
var Li = emotion_styled_browser_esm/* default.li */.Z.li(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 26px;\n"])));
var StyledPricingCard = (0,emotion_styled_browser_esm/* default */.Z)(PricingCard/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: auto;\n\n  margin-bottom: 50px;\n  max-width: 300px;\n  background: ", ";\n\n  & h3 {\n    margin-top: 35px;\n    color: ", ";\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.GREEN;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.BEIGE;
});
var Row = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  margin: 50px auto;\n  align-items: center;\n\n  @media (max-width: ", ") {\n    flex-direction: ", ";\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakPoints.mobile;
}, function (_ref5) {
  var reverse = _ref5.reverse;
  return reverse ? 'column-reverse' : 'column';
});
var ImgWrapperDashboard = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 0 0 auto;\n  border-radius: 6px;\n\n  width: 300px;\n  margin: 0 40px;\n"])));
var ImgWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 0 0 auto;\n  height: 350px;\n  width: 300px;\n  margin: 0 40px;\n"])));
var StyledH2 = (0,emotion_styled_browser_esm/* default */.Z)(typography.H2)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 100px 0 30px;\n  text-align: center;\n"])));

var Foretag = function Foretag() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHero/* default */.Z, {
      title: "F\xF6retag",
      text: "Ta ett steg n\xE4rmare framtiden"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography.H2, {
            children: "Enkel Adminportal"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledP, {
            children: "Spara v\xE4rdefull tid, inga on\xF6diga timmar f\xF6r att best\xE4lla och administrera pappers visitkort. Ni f\xE5r ett f\xF6retagsspecifikt gr\xE4nssnitt f\xF6r ett samlat utseende f\xF6r alla anst\xE4llda. DIGITO underl\xE4ttar hantering samt skapandet av era digitala visitkort."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImgWrapperDashboard, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: dashboard,
            alt: "business-img",
            layout: "responsive",
            placeholder: "blur"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
        reverse: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImgWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: business_group,
            alt: "business-img",
            layout: "responsive",
            placeholder: "blur"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography.H2, {
            children: "Det skall vara enkelt"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledP, {
            children: "Vi tycker att det skall vara enkelt och smidigt att dela kontaktuppgifter. Exempel hur v\xE5ra kunder anv\xE4nder DIGITO:"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Li, {
              children: "Digitalt visitkort"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Li, {
              children: "Mailsignatur"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Li, {
              children: "Sociala medier"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Li, {
              children: "Digitala m\xF6ten"
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledH2, {
        children: "Prata med oss f\xF6r en skr\xE4ddarsydd f\xF6retagsplan"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPricingCard, {
        item: pricingInfo,
        buttonColor: "primary"
      }, pricingInfo.title)]
    })]
  });
};

Foretag.layoutOptions = {
  backgroundColor: '#e9d3b8',
  footer: true,
  noBottomSpacing: true
};
/* harmony default export */ var foretag = (Foretag);

/***/ }),

/***/ 11230:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/foretag",
      function () {
        return __webpack_require__(7374);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [415,675,774,888,179], function() { return __webpack_exec__(11230); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);